import RegExpSpecialSymbols from "./RegExpSpecialSymbols";

function StringBuilder()
{
    this.strings = [];
}

StringBuilder.prototype.append = function( s )
{
    this.strings.push(s);
    return this;
};

StringBuilder.prototype.toString = function()
{
    return this.strings.join("");
};

export default function DiacriticsUtil() {}

DiacriticsUtil.a_CODE = "a".charCodeAt( 0 );
DiacriticsUtil.z_CODE = "z".charCodeAt( 0 );

DiacriticsUtil.makeMatchingRegexp = function( word )
{
    var chars = word.toLowerCase();
    var result = new StringBuilder();
    for( var i = 0; i < chars.length; i++ )
    {
        var c = chars.charAt( i );
        var cCode = c.charCodeAt( 0 );
        if( cCode >= DiacriticsUtil.a_CODE && cCode <= DiacriticsUtil.z_CODE )
        {
            var ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[ c ];
            var ligatureEnd = i + 1;
            while( ligaturesSubMap != null && ligatureEnd < chars.length )
            {
                var c2 = chars.charAt( ligatureEnd );
                var c2Code = c2.charCodeAt( 0 );
                if( c2Code < DiacriticsUtil.a_CODE || c2 > DiacriticsUtil.z_CODE || !ligaturesSubMap[ c2 ] )
                    break;

                // ligature detected
                ligatureEnd++;

                // continue searching for other possible ligatures
                ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[ c2 ];
            }
            if( ligatureEnd - i > 1 )
            {
                // found ligatures
                var ligatureSequenceInTheMiddle = ligatureEnd - i > 2 && (i > 0 || ligatureEnd < chars.length);
                if( ligatureSequenceInTheMiddle )
                    result.append( '(' );
                DiacriticsUtil.appendLigaturesPattern( chars, i, ligatureEnd, result );
                if( ligatureSequenceInTheMiddle )
                    result.append( ')' );
                i = ligatureEnd - 1;
            }
            else
            {
                if( ligaturesSubMap != null && ligatureEnd == chars.length )
                {
                    if( chars.length > 1 )
                        result.append( '(' );
                    DiacriticsUtil.appendDiacriticsPattern( c, result );

                    for( var e in ligaturesSubMap )
                        //noinspection JSUnfilteredForInLoop
                        result.append( '|' ).append( ligaturesSubMap[ e ] );

                    if( chars.length > 1 )
                        result.append( ')' );
                }
                else
                {
                    DiacriticsUtil.appendDiacriticsPatternWithParentheses( c, result );
                }
            }
            continue;
        }

        var charWithoutDiacritics = window.DiacriticsUtilConstants.DIACRITICS_REVERSE_MAP[ c ];

        if( charWithoutDiacritics )
        {
            DiacriticsUtil.appendDiacriticsPatternWithParentheses( charWithoutDiacritics, result );
            continue;
        }

        var ligatureExpansion = window.DiacriticsUtilConstants.LIGATURES_REVERSE_MAP[ c ];
        if( ligatureExpansion )
        {
            // ligatures matching should be diacritics insensitive too, so we need to match all variants
            result.append( '(' ).append( window.DiacriticsUtilConstants.LIGATURES[ ligatureExpansion.charAt(0) ][ ligatureExpansion.charAt(1) ] ).append( "|(" ).append( ligatureExpansion ).append( "))" );
            continue;
        }

        result.append( RegExpSpecialSymbols.escapeRegexpSpecialSymbols( c ) );
    }

    return result.toString();
};




DiacriticsUtil.appendLigaturesPattern = function( chars, fromIdx, toIdx, pattern )
{
    if( toIdx - fromIdx == 1 ) // one char
    {
        DiacriticsUtil.appendDiacriticsPatternWithParentheses( chars.charAt(toIdx - 1), pattern );
    }
    else if( toIdx - fromIdx == 2 ) // one possible ligature
    {
        DiacriticsUtil.appendLigaturePattern( chars, fromIdx, pattern );
    }
    else if( toIdx - fromIdx > 10 ) // two many possible ligatures, this may cause OutOfMemoryError
    {
        DiacriticsUtil.appendApproximateRegex( chars, fromIdx, toIdx, pattern );
    }
    else
    {
        for( var i = fromIdx; i < toIdx - 1; i++ )
        {
            pattern.append( '(' );
            if( i > fromIdx )
                DiacriticsUtil.appendInternalLigaturesPattern( chars, fromIdx, i, pattern );
            DiacriticsUtil.appendLigaturePattern( chars, i, pattern );
            if( i + 2 < toIdx )
                DiacriticsUtil.appendInternalLigaturesPattern( chars, i + 2, toIdx, pattern );
            pattern.append( ')' );
            if( i + 2 < toIdx )
                pattern.append( '|' );
        }
    }
};



DiacriticsUtil.appendApproximateRegex = function(chars, fromIdx, toIdx, buf)
{
    var idx = fromIdx;
    var uniqueChars = {};
    uniqueChars[ chars.charAt( idx ) ] = true;
    var ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[ chars.charAt( idx ) ];
    while( ++idx < toIdx )
    {
        uniqueChars[ chars.charAt( idx ) ] = true;
        if( ligaturesSubMap )
        {
            var ligatures = ligaturesSubMap[ chars.charAt( idx ) ];
            if( ligatures )
                uniqueChars[ ligatures ] = true;
        }
        ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[ chars.charAt( idx ) ];
    }
    buf.append( '[' );

    for( var str in uniqueChars )
        //noinspection JSUnfilteredForInLoop
        buf.append( str );

    buf.append( "]{" )
       .append( Math.ceil( (toIdx - fromIdx) / 2) )
       .append( ',' )
       .append( toIdx - fromIdx )
       .append( "}" );
};


DiacriticsUtil.appendInternalLigaturesPattern = function(chars, fromIdx, toIdx, buf)
{
    if( toIdx - fromIdx > 2 )
        buf.append( '(' );
    DiacriticsUtil.appendLigaturesPattern( chars, fromIdx, toIdx, buf );
    if( toIdx - fromIdx > 2 )
        buf.append( ')' );
};

DiacriticsUtil.appendLigaturePattern = function( chars, ligatureIdx, buf )
{
    var ligatureSubMap = window.DiacriticsUtilConstants.LIGATURES[ chars.charAt( ligatureIdx ) ];
    if( !ligatureSubMap )
        return false;
    var ligaturePattern = ligatureSubMap[ chars.charAt( ligatureIdx + 1 ) ];
    if( !ligaturePattern )
        return false;
    buf.append( "(" ).append( ligaturePattern ).append( "|(" );
    DiacriticsUtil.appendDiacriticsPatternWithParentheses( chars.charAt( ligatureIdx ), buf );
    if( chars.charAt( ligatureIdx + 1 ) == chars.charAt( ligatureIdx ) )
        buf.append( "{2}" );
    else
        DiacriticsUtil.appendDiacriticsPatternWithParentheses( chars.charAt( ligatureIdx + 1 ), buf );
    buf.append( "))" );
    return true;
};

DiacriticsUtil.appendDiacriticsPatternWithParentheses = function( charWithoutDiacritics, buf )
{
    buf.append( '(' );
    DiacriticsUtil.appendDiacriticsPattern( charWithoutDiacritics, buf );
    buf.append( ')' );
};

DiacriticsUtil.appendDiacriticsPattern = function( charWithoutDiacritics, buf )
{
    buf.append( charWithoutDiacritics ).append( '|' ).append( DiacriticsUtil.getDiacriticsPattern( charWithoutDiacritics ) );
};

DiacriticsUtil.getDiacriticsPattern = function( charWithoutDiacritics )
{
    return window.DiacriticsUtilConstants.DIACRITICS[charWithoutDiacritics.charCodeAt(0) - DiacriticsUtil.a_CODE];
};



// WEBPACK FOOTER //
// ./web/js/util/DiacriticsUtil.js